module.exports = __webpack_public_path__ + "static/media/facebook.20caac44.svg";